import React from "react";
import { ToastContainer } from "react-toastify";

import { BroadcastEditProvider } from "../BroadcastEditContainer";
import BroadcastComposer from "./BroadcastComposer";

const BroadcastComposerContainer = (props) => (
  <BroadcastEditProvider {...props}>
    <ToastContainer icon={false} />
    <BroadcastComposer />
  </BroadcastEditProvider>
);

export default BroadcastComposerContainer;
